export default __webpack_public_path__ + "static/media/Start_Over_Button.b1f9d70d.svg";